module.exports = __webpack_public_path__ + "img/zambia.9ad4c5ae.svg";